import { AuthGuardService } from './authentication/auth-guard.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';

export const routes: Routes = [
{
    path: '',
    component: FullComponent,
    //loadChildren: './main-routing/main-routing.module#MainRoutingModule'
    children: [
        { path: '', redirectTo: '/login', pathMatch: 'full',  },
        { path: 'audience-plus-status', loadChildren: './audience-plus-status-module/audience-plus-status-module.module#AudiencePlusStatusModuleModule', canActivate : [AuthGuardService]},
        { path: 'dashboard', loadChildren: './starter/starter.module#StarterModule', canActivate : [AuthGuardService]},
        { path: 'change-billing', loadChildren: './change-billing/change-billing.module#ChangeBillingModule', canActivate : [AuthGuardService]},
        { path: 'users', loadChildren: './users/user.module#UsersModule', canActivate : [AuthGuardService]},
        { path: 'user-pages/:id', loadChildren: './user-pages/userPages.module#UserPagesModule' },
        { path: 'component', loadChildren: './component/component.module#ComponentsModule' },
    ]
},
{
    path: '',
    component: BlankComponent,
    children: [
        { path: '', redirectTo: '/login', pathMatch: 'full' },
        { path: 'login', loadChildren: './authentication/authentication.module#AuthenticationModule' },
    ]
},
{
    path: '**',
    redirectTo: 'dashboard'
}];

@NgModule({
    imports: [RouterModule.forRoot(routes), NgbModule.forRoot()],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/igor/Projects/onechat/admin-dashboard/src/app/app-routing.module.ts